import React from 'react';
import Carousel from '../Carousel';

type ArticleCarouselProps = {
  images: {
    url: string;
  }[];
};

// TODO (VS): Find a test case for this component
const ArticleCarousel: React.FC<ArticleCarouselProps> = ({ images }) => {
  return (
    <div className="relative w-full h-full">
      <Carousel
        emblaOptions={{
          loop: true,
        }}
        fullWidthSlides={true}
      >
        {images.map((image, index) => (
          <div key={index} className="relative h-full">
            <img
              className="object-cover object-center w-full min-h-full"
              src={image.url}
              alt="image"
            />
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default ArticleCarousel;
